import { createContext } from 'react';
import { AccountType } from '@make-software/csprclick-core-types';

type ConnectedAccountContextValue = {
  connectedAccount: AccountType | null;
  stampBalance: number | null;
  refreshStampBalance: () => void;
};

export const ConnectedAccountContext =
  createContext<ConnectedAccountContextValue>({
    connectedAccount: null,
    stampBalance: null,
    refreshStampBalance: () => {}
  });
